import { FormControl, TextField, TextFieldProps } from '@mui/material';
import {
  Controller,
  ControllerFieldState,
  ControllerProps,
  ControllerRenderProps,
  FieldValues,
  UseFormStateReturn,
} from 'react-hook-form';

type TextFieldControllerProps<T extends FieldValues> = Omit<ControllerProps<T>, 'render'> &
  Partial<{
    TextFieldProps?:
      | TextFieldProps
      | ((options: {
          field: ControllerRenderProps<T>;
          fieldState: ControllerFieldState;
          formState: UseFormStateReturn<T>;
        }) => Partial<TextFieldProps>);
  }>;

function TextFieldController<T extends FieldValues>({
  TextFieldProps,
  ...rest
}: TextFieldControllerProps<T>) {
  return (
    <Controller
      {...rest}
      render={({ field: { ref, ...field }, fieldState, ...rest }) => (
        <FormControl fullWidth>
          <TextField
            {...field}
            inputRef={ref}
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState?.error?.message || ''}
            variant="standard"
            disabled={rest.formState.isSubmitting}
            {...(typeof TextFieldProps === 'function'
              ? TextFieldProps({ field: { ...field, ref }, fieldState, ...rest })
              : TextFieldProps)}
          />
        </FormControl>
      )}
    />
  );
}

export default TextFieldController;
